export default __webpack_public_path__ + "node_modules/ckeditor/config.js";